import React from 'react';

interface ERupiVoucherSearchProps {
  saralcode: string;
  onSaralcodeChange: (value: string) => void;
  onSubmit: () => void;
  loading: boolean;
  error?: string;
}

const ERupiVoucherSearch: React.FC<ERupiVoucherSearchProps> = ({
  saralcode,
  onSaralcodeChange,
  onSubmit,
  loading,
  error,
}) => {
  return (
    <div className="w-full p-3 flex items-center justify-center">
      <div className="w-full flex gap-2">
        <input
          type="text"
          id="saralCodeInput"
          value={saralcode}
          onChange={(e) => onSaralcodeChange(e.target.value)}
          placeholder="Please Enter Voucher Saral Code"
          className={`w-full flex-auto max-w px-3 py-2 border rounded-md focus:outline-none ${
            error ? 'border-red-500' : 'border-gray-300'
          }`}
        />
        <button
          type="submit"
          onClick={onSubmit}
          disabled={loading}
          className="px-5 flex-auto w-[15%] py-2 text-sm font-medium text-white bg-brand rounded-md hover:bg-brand/80 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-brand disabled:opacity-50 disabled:cursor-not-allowed"
        >
          {loading ? 'Loading...' : 'Get Details'}
        </button>
      </div>
    </div>
  );
};

export default ERupiVoucherSearch;

